import React, { useState, useRef, useEffect } from "react";
import { Container, Input, Form, FormGroup, Label, Button,Col,Row} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import whiteLogo from "../../../assets/logos/White on Transparent.png";
import "../Login.css";
import { Link } from "react-router-dom";
import { handleForgetPassword } from "../../../store/actions/authAction";
function ForgetPassword() {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState("");
    var appInfo = useSelector((state) => state.appInfo);
    const dispatch = useDispatch();
    const timer = useRef();  
    const navigate= useNavigate()
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        };
      
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
       useEffect(()=>{
        if(windowSize.width>=778){
            navigate("/auth");
        }

      },[windowSize.width])
    const resetError = () => {
        setError("");
        clearTimeout(timer);
      };
      const handleClick=()=>{
        navigate("/mobile-forget-password-otp", { state: { phoneNumber: phoneNumber } })
      }
     
      const forgetPassword = () => {
        console.log("function login called");
        if (phoneNumber.length !== 10) {
          setError("*Mobile number should contain only 10 digits!!");
          timer.current = setTimeout(resetError, 1500);
        } else {
          let data = {
            countryCode: "+91",
            phoneNumber: phoneNumber,
          };
          dispatch(
            handleForgetPassword(data, (args) => {
              console.log("ARGS->", args);
              handleClick()
            })
          );
        }
      };
  return (
    <Container className="bgImg" >
        <Row>
        <center>
            <Link to="/">
              <img style={{ width: 250,marginBottom:20,marginTop:40 }} src={whiteLogo} />
            </Link>
          </center>
        </Row>   
    <Row  style={{
             marginTop: 10,
             height:380,
             background: "rgba(216,216,216,0.48)",
             boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
             borderRadius: 5,
             backdropFilter: "blur(5px)",
             padding: 20,
             margin:5,
        }}>
        <Col md="10">
        <Form>
            <FormGroup>
              <Input
                className="inputBox"
                onChange={(e) => setPhoneNumber(e.target.value)}
                style={{ marginTop: 55 }}
                placeholder="Please Enter Mobile Number"
                autoComplete="off"
                value={phoneNumber}
              />
            </FormGroup>
            <center>

            <Button
              className="submitButton"
              style={{ marginTop: 32 }}
              onClick={forgetPassword}
            >
              {
                appInfo.loading?"Loading..." : "Send OTP"
              }
               
            </Button>

            {error !== "" ? (
                <p style={{ color: "#9e1212", marginTop: 10 }}>{error}</p>
                ) : null}
            </center>
            <center>

            <Button
              className="submitButton"
              style={{ marginTop: 32,color:'#76561c',background:'white',fontSize:13 }}
              onClick={()=>(navigate("/mobile-auth"))}
              >
              Signin Now
            </Button>
              </center>
          </Form>

        </Col>
    </Row>
</Container>
  )
}

export default ForgetPassword